module.exports = __webpack_public_path__ + "static/img/fenxi2.d5a47a25.png";